import { Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import DateFormat from '../../../elements/Date/DateFormat';
import InfoIcon from '../../../elements/InfoIcon/InfoIcon';
import OwnerCell from '../../../elements/TableCells/OwnerCell';
import { ArtifactInfo } from '../../types/artifacts-type';
import ArtifactSections from './ArtifactSections';
import Section from './Section';

const ArtifactPipelineDefinition: FC<ArtifactPipelineDefinitionProps> = ({
  artifact,
}) => {
  const { classes } = useStyles();
  const { cicdDescription } = artifact;
  if (!artifact.cicdDescription?.pipeline) {
    return null;
  }

  const { owner, developer, creationTime, executed } =
    artifact.cicdDescription.pipeline;

  const pipelineCreatedAt = creationTime
    ? new Date(Number(creationTime))
    : undefined;
  const pipelineLastExecution = cicdDescription?.pipelineExecution?.createTime
    ? new Date(cicdDescription.pipelineExecution?.createTime)
    : undefined;

  return (
    <div className={classes.artifactPipelineDefinition}>
      <Typography variant='body2' color='text.primary' fontWeight={600}>
        Pipeline Definition
        <InfoIcon
          marginX={2}
          title={
            'Pipeline definition describes general information about the pipeline (e.g How many times it was run, when was the last time it was executed and so forth)'
          }
        />
      </Typography>

      <ArtifactSections>
        <Section label='Pipeline Owner'>
          {owner && <OwnerCell owners={[owner]} />}
        </Section>

        <Section label='Pipeline Developer'>
          {developer && <OwnerCell owners={[developer]} />}
        </Section>

        <Section label='Pipeline Creation Time'>
          {pipelineCreatedAt && (
            <DateFormat date={pipelineCreatedAt} color='text.primary' bigSize />
          )}
        </Section>

        <Section label='Executed'>
          {executed && (
            <Typography variant='body2' color='text.primary'>
              {executed}
            </Typography>
          )}
        </Section>

        <Section label='Last Execution Time'>
          {pipelineLastExecution && (
            <DateFormat
              date={pipelineLastExecution}
              color='text.primary'
              bigSize
            />
          )}
        </Section>
      </ArtifactSections>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  artifactPipelineDefinition: {
    paddingBlock: theme.spacing(2),
  },
}));

export interface ArtifactPipelineDefinitionProps {
  artifact: ArtifactInfo;
}

export default ArtifactPipelineDefinition;
